export const convertToWebP = (file) => {
    return new Promise((resolve) => {
        const img = new Image();
        const reader = new FileReader();
  
        reader.onload = (e) => {
            img.src = e.target.result;
        };
  
        img.onload = () => {
            const canvas = document.createElement("canvas");
            const scale = 0.9; 
            canvas.width = img.width * scale;
            canvas.height = img.height * scale;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
  
            // Try lossless WebP conversion
            canvas.toBlob(
                (blob) => {
                    const webpFile = new File(
                        [blob],
                        file.name.replace(/\.\w+$/, ".webp"),
                        { type: "image/webp" }
                    );
                    resolve(webpFile);
                },
                "image/webp",
            );
        };
  
        reader.readAsDataURL(file);
    });
};